<!-- Desktop -->
<div
  class="hidden md:flex relative w-full items-center justify-center mb-8"
  [style.height.px]="outerRingSize() + 80"
>
  <!-- Inner orbit ring -->
  <div
    class="orbit-ring orbit-ring--inner absolute rounded-full border border-slate-400/25 dark:border-white/10"
    [style.width.px]="innerRingSize()"
    [style.height.px]="innerRingSize()"
  ></div>

  <!-- Outer orbit ring (rotating) -->
  <div
    class="orbit-ring orbit-ring--outer absolute rounded-full border border-dashed border-slate-400/20 dark:border-white/8"
    [style.width.px]="outerRingSize()"
    [style.height.px]="outerRingSize()"
  ></div>

  <!-- Protagonists (children — center) -->
  @for (child of protagonists(); track child.id; let i = $index) {
  <div
    tabindex="0"
    class="orbit-node orbit-node--protagonist orbit-tooltip-trigger absolute z-20 flex flex-col items-center"
    [style.--i]="i"
    [style.transform]="'translate(calc(-50% + ' + child.x + 'px), calc(-50% + ' + child.y + 'px))'"
    [attr.data-tooltip]="child.name"
  >
    <div class="orbit-protagonist-float" [style.--i]="i">
      <div class="orbit-protagonist-glow"></div>
      <div
        class="relative w-14 h-14 rounded-full bg-white dark:bg-slate-800 border-2 border-primary/40 shadow-lg flex items-center justify-center overflow-hidden"
      >
        @if (child.photoURL) {
        <img
          [src]="child.photoURL"
          [alt]="child.name"
          class="w-full h-full object-cover"
        />
        } @else {
        <span class="font-serif font-bold text-base text-primary"
          >{{ child.initial }}</span
        >
        }
      </div>
    </div>
  </div>
  }

  <!-- Members (orbiting — outer ring) -->
  @for (member of members(); track member.id; let i = $index) {
  <div
    tabindex="0"
    class="orbit-node orbit-node--member orbit-tooltip-trigger absolute z-10 flex flex-col items-center"
    [style.--i]="i"
    [style.transform]="'translate(calc(-50% + ' + member.x + 'px), calc(-50% + ' + member.y + 'px))'"
    [attr.data-tooltip]="member.name"
  >
    <div
      class="w-11 h-11 rounded-full flex items-center justify-center shadow-sm"
      [class]="member.pending
          ? 'bg-primary/5 dark:bg-primary/10 border-2 border-dashed border-primary/40 text-primary/70'
          : 'bg-primary/10 dark:bg-primary/20 border-2 border-primary text-primary'"
    >
      @if (member.photoURL) {
      <img
        [src]="member.photoURL"
        [alt]="member.name"
        class="w-full h-full object-cover rounded-full"
      />
      } @else {
      <span class="font-serif font-bold text-sm">{{ member.initial }}</span>
      }
    </div>
  </div>
  }
</div>

<!-- Mobile -->
<div
  class="md:hidden relative w-full flex items-center justify-center mb-6"
  [style.height.px]="outerRingSize() * mobileScale() + 60"
>
  <!-- Inner ring -->
  <div
    class="orbit-ring orbit-ring--inner absolute rounded-full border border-slate-400/25 dark:border-white/10"
    [style.width.px]="innerRingSize() * mobileScale()"
    [style.height.px]="innerRingSize() * mobileScale()"
  ></div>

  <!-- Outer ring -->
  <div
    class="orbit-ring orbit-ring--outer absolute rounded-full border border-dashed border-slate-400/20 dark:border-white/8"
    [style.width.px]="outerRingSize() * mobileScale()"
    [style.height.px]="outerRingSize() * mobileScale()"
  ></div>

  <!-- Protagonists -->
  @for (child of protagonists(); track child.id; let i = $index) {
  <button
    type="button"
    class="orbit-node orbit-node--protagonist orbit-tooltip-trigger absolute z-20 flex flex-col items-center"
    [style.--i]="i"
    [style.transform]="'translate(calc(-50% + ' + child.x * mobileScale() + 'px), calc(-50% + ' + child.y * mobileScale() + 'px))'"
    [attr.data-tooltip]="child.name"
  >
    <div class="orbit-protagonist-float" [style.--i]="i">
      <div class="orbit-protagonist-glow orbit-protagonist-glow--mobile"></div>
      <div
        class="relative w-11 h-11 rounded-full bg-white dark:bg-slate-800 border-2 border-primary/40 shadow-md flex items-center justify-center overflow-hidden"
      >
        @if (child.photoURL) {
        <img
          [src]="child.photoURL"
          [alt]="child.name"
          class="w-full h-full object-cover"
        />
        } @else {
        <span class="font-serif font-bold text-xs text-primary"
          >{{ child.initial }}</span
        >
        }
      </div>
    </div>
  </button>
  }

  <!-- Members -->
  @for (member of members(); track member.id; let i = $index) {
  <button
    type="button"
    class="orbit-node orbit-node--member orbit-tooltip-trigger absolute z-10 flex flex-col items-center"
    [style.--i]="i"
    [style.transform]="'translate(calc(-50% + ' + member.x * mobileScale() + 'px), calc(-50% + ' + member.y * mobileScale() + 'px))'"
    [attr.data-tooltip]="member.name"
  >
    <div
      class="w-9 h-9 rounded-full flex items-center justify-center shadow-sm"
      [class]="member.pending
          ? 'bg-primary/5 dark:bg-primary/10 border-2 border-dashed border-primary/40 text-primary/70'
          : 'bg-primary/10 dark:bg-primary/20 border-2 border-primary text-primary'"
    >
      @if (member.photoURL) {
      <img
        [src]="member.photoURL"
        [alt]="member.name"
        class="w-full h-full object-cover rounded-full"
      />
      } @else {
      <span class="font-serif font-bold text-xs">{{ member.initial }}</span>
      }
    </div>
  </button>
  }
</div>
